import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = () => {
  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <Navbar />
        {/* <main className="flex-grow-1 layout-main"> */}
          <Outlet />
        {/* </main> */}
        <Footer />
      </div>
    </>
  );
};

export default Layout;